import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { PaymentsInitStepDeclaration } from "./Steps/PaymentInitStep";

const paymentsMainStartupFlow = new FlowDefinition("MyAccountPaymentsFlow");

paymentsMainStartupFlow.addStep(PaymentsInitStepDeclaration);

paymentsMainStartupFlow.setStartStep("MyAccountPaymentsInit_Step");

export const myAccountPaymentStartupFlowDefinition = new StepDefinition({
    stepName: "MyAccountPaymentsFlow",
    stepFlow: paymentsMainStartupFlow,
    contextIsolation: false
})
